import { userConstants } from "../_constants";

let user = JSON.parse(localStorage.getItem("user"));
const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
    switch (action.type) {
        case userConstants.LOGIN_REQUEST:
            return {
                loggingIn: true,
                user: action.user
            };
        case userConstants.LOGIN_SUCCESS:
            return {
                loggedIn: true,
                user: action.user
            };
        case userConstants.LOGIN_FAILURE:
            return {};
        case userConstants.LOGOUT:
            return {};

        case userConstants.CAMPAIGN_SIGNED:
            user.campaignSigned = action.campaignId;
            return {
                loggedIn: true,
                user: user
            };

        case userConstants.UPDATE_ACCOUNT_BALANCE:
            user.balance = action.balance;
            return {
                loggedIn: true,
                user: user
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/authentication.reducer.js